import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { UPDATE_MODIFIER_CATEGORY } from "src/constants/mutations";
import { failureToast, successToast } from "src/utils/toasts";
import { UpdateModifierCategoryInput } from "src/interfaces/modifier.interface";
import { update_modifier_category } from "src/store/features/modifier-categories-slice";

export const useUpdateModifierCategory = () => {
  const dispatch = useDispatch();
  const { axBe } = useAxiosInterceptor();
  
  const [isUpdatingModifierCategory, setIsUpdatingModifierCategory] = useState(false);

  const updateModifierCategoryMutation = useCallback(
    async (updateModifierCategoryInput: UpdateModifierCategoryInput) => {
      setIsUpdatingModifierCategory(true);

      try {
        const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
          query: UPDATE_MODIFIER_CATEGORY,
          variables: {
            updateModifierCategoryInput,
          },
        });

        if (data?.data?.updateModifierCategory) {
          // Update the category in Redux state
          dispatch(update_modifier_category(data.data.updateModifierCategory));
          successToast("Modifier category has been updated successfully!");
        }
      } catch (err) {
        console.error("Error updating modifier category:", err);
        const errorMessage = "Failed to update modifier category";
        failureToast(errorMessage);
      } finally {
        setIsUpdatingModifierCategory(false);
      }
    },
    [axBe, dispatch]
  );

  return {
    isUpdatingModifierCategory,
    updateModifierCategory: updateModifierCategoryMutation,
  };
};
